import { transformDatesHook } from './features/shared/hooks/dateTransform';

export const registerDateHooks = (client, serviceNames = []) => {
  serviceNames.forEach((serviceName) => {
    client.service(serviceName).hooks({
      before: {
        create: [transformDatesHook],
        update: [transformDatesHook],
        patch: [transformDatesHook],
      },
    });
  });
};
